import styled, { createGlobalStyle, css } from "styled-components";
import Link from "ui-components/Link";
const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    text-size-adjust: none;
    margin: 0;
    padding: 0;
  }
 
  :root,
  html,
  body {
    margin: 0;
    padding: 0;
    font-family: OpenSans, sans-serif;
    -webkit-font-smoothing: antialiased;
    font-size: 14px;
    line-height: 20px;
  }
  
   @font-face {
    font-family: "OpenSans";
    src: local("OpenSans-Light"), url("/static/fonts/Open_Sans/OpenSans-Light.ttf") format("truetype");
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: "OpenSans";
    src: local("OpenSansLight-Italic"), url("/static/fonts/Open_Sans/OpenSans-LightItalic.ttf") format("truetype");
    font-weight: 300;
    font-style: italic;
  }
  
  @font-face {
    font-family: "OpenSans";
    src: local("OpenSans"),  url("/static/fonts/Open_Sans/OpenSans-Regular.ttf") format("truetype");
    font-weight: 400;
    font-style: normal;
  }
  
  @font-face {
    font-family: "OpenSans";
    src: local("OpenSans-Italic"), url("/static/fonts/Open_Sans/OpenSans-RegularItalic.ttf") format("truetype");
    font-weight: 400;
    font-style: italic;
  }
  
  @font-face {
    font-family: "OpenSans";
    src: local("OpenSans-Semibold"), url("/static/fonts/Open_Sans/OpenSans-SemiBold.ttf") format("truetype");
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: "OpenSans";
    src: local("OpenSans-SemiboldItalic"), url("/static/fonts/Open_Sans/OpenSans-SemiBoldItalic.ttf") format("truetype");
    font-weight: 600;
    font-style: italic;
  }

  @font-face {
    font-family: "OpenSans";
    src: local("OpenSans-Bold"), url("/static/fonts/Open_Sans/OpenSans-Bold.ttf") format("truetype");
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: "OpenSans";
    src: local("OpenSans-BoldItalic"), url("/static/fonts/Open_Sans/OpenSans-BoldItalic.ttf") format("truetype");
    font-weight: 700;
    font-style: italic;
  }

  @font-face {
    font-family: "OpenSans";
    src: local("OpenSans-Extrabold"), url("/static/fonts/Open_Sans/OpenSans-ExtraBold.ttf") format("truetype");
    font-weight: 800;
    font-style: normal;
  }

  @font-face {
    font-family: "OpenSans";
    src: local("OpenSans-ExtraboldItalic"), url("/static/fonts/Open_Sans/OpenSans-ExtraBoldItalic.ttf") format("truetype");
    font-weight: 800;
    font-style: italic;
  }
`; // Safari Like color rgba(0, 0, 0, 0.5)

const getSafariLikeScrollBar = (thumbColor = "rgba(221, 227, 227, 1)") => css`
  /* Turn on custom 8px wide scrollbar */
  ::-webkit-scrollbar {
    /* 1px wider than Lion. */
    /* Visual like 6px in Figma */
    width: 10px;
    /* This is more usable for users trying to click it. */
    background-color: rgba(0, 0, 0, 0);
    -webkit-border-radius: 100px;
  }
  /* hover effect for both scrollbar area, and scrollbar 'thumb' */
  ::-webkit-scrollbar:hover {
    background-color: rgba(0, 0, 0, 0.09);
  }

  /* The scrollbar 'thumb' ...that marque oval shape in a scrollbar */
  ::-webkit-scrollbar-thumb:vertical {
    /* rgba(0, 0, 0, 0.5) This is the EXACT color of Mac OS scrollbars. 
     Yes, I pulled out digital color meter */
    background: ${thumbColor};
    -webkit-border-radius: 100px;
    background-clip: padding-box;
    border: 2px solid rgba(0, 0, 0, 0);
    /* Prevent it from getting too small */
    min-height: 81px;
  }
  ::-webkit-scrollbar-thumb:vertical:active {
    /* Some darker color when you click it */
    background: rgb(210, 210, 210);
    -webkit-border-radius: 100px;
  }

  /* Firefox options */
  scrollbar-color: ${thumbColor} rgba(255, 255, 255, 0) !important;
  scrollbar-width: thin !important;
`;

const customHTMLElemStylesForOffer = css`
  > :first-child {
    margin-top: 6px;
  }

  > :last-child {
    margin-bottom: 80px;

    @media screen and (min-width: 426px) {
      margin-bottom: 6px;
    }
  }

  h1 {
    font-size: 320%;
    line-height: 1.35;
    font-style: normal;
    margin: 1.5em 0 0.8em;
  }

  h2 {
    font-weight: bold;
    font-size: 200%;
    margin: 1em 0 0.8em;
  }

  h3 {
    font-weight: normal;
    text-transform: uppercase;
    font-size: 150%;
    margin: 1.75em 0 0.8em;
  }

  h4 {
    font-weight: normal;
    font-size: 150%;
    margin: 1.5em 0 0.8em;
  }

  h5 {
    font-weight: normal;
    font-style: italic;
    font-size: 150%;
    margin: 1.5em 0 0.8em;
  }

  h6 {
    font-weight: bold;
    font-size: 100%;
    margin: 1.5em 0 0.8em;
  }

  p {
    margin: 14px 0;
    text-align: left;
    font-size: 14px;
  }

  ul,
  ol {
    text-align: left;
    text-indent: 2em;
    margin-bottom: 1.5em;
  }

  li {
    list-style-position: inside;
    text-indent: 1rem;
  }

  > p,
  > ul,
  > li {
    font-size: 14px;
    line-height: 19px;
  }
`;
const ModalContainer = styled.div`
  font-style: normal;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /* Remove modal spaces */
  margin: -0.2rem -1rem -1rem -1rem;

  width: 594px;
  height: 538px;
  max-width: 100vw;
  max-height: 100vh;
  padding: 0 26px;

  @media screen and (max-width: 425px) {
    padding: 0;
    width: auto;

    /* Fallback for browsers that do not support Custom Properties */
    height: 100vh;
    /* --vh - defind on render modal custom property calc right value by spec 1% by viewport height */
    height: calc(var(--vh, 1vh) * 100);
  }

  & * {
    font-family: "OpenSans", sans-serif !important;
  }
`;
const Title = styled.div`
  font-weight: 600;
  color: #211e24;
  text-align: center;

  font-size: 20px;
  line-height: 27px;
  padding: 38px 43px 16px 43px;
  flex-shrink: 1;
  min-height: 108px;
  flex-basis: 108px;

  /* Hack: Fix styled component production optimization affected /books/* */
  min-width: 100% !important;
  /* Hack: Fix styled component production optimization affected /faq/ */
  margin-top: 0 !important;

  @media screen and (min-width: 426px) {
    font-size: 24px;
    line-height: 33px;
    padding: 52px 0 29px 0;
    min-height: 114px;
    flex-basis: 114px;
  }
`;
const Description = styled.div`
  border-width: 1px;
  border-style: solid;
  border-color: #dde3e3;
  border-radius: 2px;
  overflow-y: scroll;
  /* Disable over-scroll page on modern browsers */
  overscroll-behavior: none;

  flex-grow: 1;
  min-width: 100% !important;

  /* Safari like scrollbar with custom thumb color, only for green browser */
  ${getSafariLikeScrollBar("#DDE3E3")};

  /* Custom styles for loaded html */
  padding: 8px 6px 0 14px;
  ${customHTMLElemStylesForOffer};
  /* Custom styles for loaded html */
`;
const MessageIP = styled.div`
  width: 540px;
  height: 64px;
  padding: 41px 0 22px 0;
  font-weight: 400;
  line-height: 32px;
`;
const LinkForm = styled(Link)`
  color: #0038f5;
`;
const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  padding-top: 24px;
  padding-bottom: 26px;

  flex-shrink: 1;
  flex-basis: 80px;
  /* HACK: Fix safari safari disregards flex-basis*/
  min-height: 80px;
  min-width: 100% !important;

  > button {
    width: 200px;
    height: 48px;
    border-radius: 6px;
  }

  @media screen and (max-width: 425px) {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 80px;
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 1) 30%,
      rgba(255, 255, 255, 0) 100%
    );

    > button {
      max-height: 48px;
    }
  }
`;
export { GlobalStyle, ModalContainer, Title, Description, ActionContainer, MessageIP, LinkForm };